import React from 'react'
import { Card } from 'components'
import { Box, Typography } from '@mui/material'
import * as sxStyles from '../AnalyticsDetails.styled'

interface ICardWithTitleProps {
  title: string
  subTitle?: string
  icon?: React.ReactNode
}

export const CardWithTitle: React.FC<ICardWithTitleProps> = ({
  title,
  subTitle,
  icon,
}) => {
  return (
    <Card sx={sxStyles.cardTitleStyle}>
      <Box sx={sxStyles.textBoxWrapper}>
        <Typography sx={sxStyles.cardTitleTypography}>{title}</Typography>
        <Typography sx={sxStyles.cardSubtitle} noWrap>
          {subTitle}
        </Typography>
        <Box sx={{ marginRight: '10px' }}>{icon}</Box>
      </Box>
    </Card>
  )
}
